export const JOIN = "join";
export const COMMAND = "command";
export const COMMAND_RESPONSE = "command:response";
export const CONTROL_GET = "webguest:control:get";
export const CONTROL_SET = "webguest:control:set";
